import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  getCoverageSummaryDashBoardDetails,
  getDetailsPriceTrendData,
  getSavedScenarioData,
  getScenarioBuilderCoverageSummaryData,
  saveScenarioAsync,
} from 'src/redux/async/electronicTool/coverage-summary.async'
import {
  getCrossTypeDetails,
  getProductTreeData,
  uploadFile,
} from 'src/redux/async/electronicTool/electronicTool'

const initialState = {
  scenarioFilterById: 'all',
  selectedFilterById: 'all',
  time: '6',
  isComponent: false,

  coverageSummaryLoader: false,
  coverageSummaryError: '',
  coverageSummaryData: null,
  // Price trend analysis
  priceTrendAnalysisDetailsList: [],
  priceTrendAnalysisLoader: false,
  priceTrendAnalysisError: '',
  // Scenario one
  coverageScenarioOneData: [],
  coverageScenarioOneLoader: false,
  coverageScenarioOneError: '',

  // Saved Scenario
  saveScenarioLoader: false,
  saveScenarioListLoader: false,
  saveScenarioListData: [],
  saveScenarioListError: '',

  // Analysis configuaration and refresh
  crossTypeDataPending: true,
  crossTypeData: {},
  selectedCrossTypes: [],
  crossTypeError: '',
  crossTypeLoader: false,

  // update component
  updateFlag: false,
}

export const coverageSummaryDashboardSlice = createSlice({
  name: 'electronic-tool/get-coverage-summary-dashboard-data',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getCoverageSummaryDashBoardDetails.pending), (state) => {
      state.coverageSummaryLoader = true
      state.coverageSummaryData = null
    })
    builder.addMatcher(isAnyOf(getCoverageSummaryDashBoardDetails.fulfilled), (state, action) => {
      state.coverageSummaryLoader = false
      state.coverageSummaryData = action.payload?.data ?? null
      state.coverageSummaryError = ''
    })
    builder.addMatcher(isAnyOf(getCoverageSummaryDashBoardDetails.rejected), (state, action) => {
      state.coverageSummaryData = null
      state.coverageSummaryLoader = false
      state.coverageSummaryError = action.payload
    })
    // Detail Price trend analysis
    builder.addMatcher(isAnyOf(getDetailsPriceTrendData.pending), (state) => {
      state.priceTrendAnalysisLoader = true
      state.priceTrendAnalysisDetailsList = []
    })
    builder.addMatcher(isAnyOf(getDetailsPriceTrendData.fulfilled), (state, action) => {
      state.priceTrendAnalysisLoader = false
      state.priceTrendAnalysisDetailsList = action.payload.data
      state.priceTrendAnalysisError = ''
    })
    builder.addMatcher(isAnyOf(getDetailsPriceTrendData.rejected), (state, action) => {
      state.priceTrendAnalysisLoader = false
      state.priceTrendAnalysisDetailsList = []
      state.priceTrendAnalysisError = ''
    })
    // Scenario one
    builder.addMatcher(isAnyOf(getScenarioBuilderCoverageSummaryData.pending), (state) => {
      state.coverageScenarioOneLoader = true
      state.coverageScenarioOneData = []
    })
    builder.addMatcher(
      isAnyOf(getScenarioBuilderCoverageSummaryData.fulfilled),
      (state, action) => {
        state.coverageScenarioOneLoader = false
        state.coverageScenarioOneData = action.payload.data
        state.coverageScenarioOneError = ''
      },
    )
    builder.addMatcher(isAnyOf(getScenarioBuilderCoverageSummaryData.rejected), (state, action) => {
      state.coverageScenarioOneLoader = false
      state.coverageScenarioOneData = []
      state.coverageScenarioOneError = ''
    })
    // Save Scenario
    builder.addMatcher(isAnyOf(saveScenarioAsync.pending), (state) => {
      state.saveScenarioLoader = true
    })
    builder.addMatcher(isAnyOf(saveScenarioAsync.fulfilled), (state, action) => {
      state.saveScenarioLoader = false
    })
    builder.addMatcher(isAnyOf(saveScenarioAsync.rejected), (state, action) => {
      state.saveScenarioLoader = false
    })
    // Update Component
    builder.addMatcher(isAnyOf(uploadFile.pending), (state) => {
      state.updateFlag = false
    })
    builder.addMatcher(isAnyOf(uploadFile.fulfilled), (state, action) => {
      state.updateFlag = true
    })
    builder.addMatcher(isAnyOf(uploadFile.rejected), (state, action) => {
      state.updateFlag = false
    })
    // get Hierarachy data
    // builder.addMatcher(isAnyOf(getProductTreeData.pending), (state) => {
    //   state.updateFlag = false
    // })
    builder.addMatcher(isAnyOf(getProductTreeData.fulfilled), (state, action) => {
      state.updateFlag = false
    })
    // builder.addMatcher(isAnyOf(getProductTreeData.rejected), (state, action) => {
    //   state.updateFlag = false
    // })
    // Get Saved Scenario
    builder.addMatcher(isAnyOf(getSavedScenarioData.pending), (state) => {
      state.saveScenarioListLoader = true
      state.saveScenarioListData = []
    })
    builder.addMatcher(isAnyOf(getSavedScenarioData.fulfilled), (state, action) => {
      state.saveScenarioListLoader = false
      state.saveScenarioListData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getSavedScenarioData.rejected), (state, action) => {
      state.saveScenarioListLoader = false
      state.saveScenarioListData = []
      state.saveScenarioListError = ''
    })
    // Cross type details for analysis
    builder.addMatcher(isAnyOf(getCrossTypeDetails.pending), (state) => {
      state.crossTypeLoader = true
      state.crossTypeData = []
    })
    builder.addMatcher(isAnyOf(getCrossTypeDetails.fulfilled), (state, action) => {
      state.crossTypeLoader = false
      state.crossTypeData = action.payload.data
      state.selectedCrossTypes = action.payload.data?.cross_types.map((el) => {
        return { label: el, value: el }
      })
      state.crossTypeDataPending = false
      state.crossTypeError = ''
    })
    builder.addMatcher(isAnyOf(getCrossTypeDetails.rejected), (state, action) => {
      state.crossTypeLoader = false
      state.crossTypeError = action.payload
    })
  },
  reducers: {
    setTimePeriod: (state, action) => {
      state.time = action.payload
      state.selectedFilterById = 'all'
      state.scenarioFilterById = 'all'
    },
    setSelectedFilterById: (state, action) => {
      state.selectedFilterById = action.payload
      state.scenarioFilterById = action.payload === 'all' ? 'all' : state.scenarioFilterById
    },
    setIsComponent: (state, action) => {
      state.isComponent = action.payload
    },
    setSelectCrossTypes: (state, action) => {
      state.selectedCrossTypes = action.payload
    },
    setScenarioFilterById: (state, action) => {
      state.scenarioFilterById = action.payload
      state.selectedFilterById = action.payload === 'all' ? 'all' : state.selectedFilterById
    },
    emptyCoverageSummarySlice: (state) => {
      state.coverageSummaryLoader = false
      state.coverageSummaryError = ''
      state.coverageSummaryData = null
      //Scenario one
      state.coverageScenarioOneData = []
      state.coverageScenarioOneLoader = false
      state.coverageScenarioOneError = ''
    },
  },
})

export const {
  emptyCoverageSummarySlice,
  setSelectCrossTypes,
  setIsComponent,
  setScenarioFilterById,
  setSelectedFilterById,
  setTimePeriod,
} = coverageSummaryDashboardSlice.actions

export default coverageSummaryDashboardSlice.reducer
